import { commonService } from './commonService';

export const uxUiDesignConsultingServices = {
  ...commonService,
  name: 'UX/UI Design Consulting Services',
  serviceType: [
    'UX Research',
    'UX/UI Design',
    'Product Discovery Workshops',
    'Design Systems Development',
    'Prototyping and MVP Design',
    'Digital Product Innovation',
  ],
  description:
    'Boldare delivers award-winning UX/UI design consulting services focused on creating user-centered, innovative digital products. Through intensive user research, prototyping, and continuous testing, we help businesses build engaging and effective digital experiences that drive results. Our agile, data-driven approach ensures designs are not only visually appealing but also aligned with user needs and business goals.',
};
